import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, description, testId }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="max-w-3xl"
      data-testid={testId}
    >
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#e63946] flex items-center gap-3 mb-5">
        <span className="inline-block w-8 h-px bg-[#e63946]" />
        {eyebrow}
      </p>
      <h2 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl sm:text-5xl md:text-6xl">
        {title}
      </h2>
      {description && (
        <p className="mt-6 text-base md:text-lg text-neutral-600 max-w-2xl leading-relaxed">
          {description}
        </p>
      )}
    </motion.div>
  );
};
